// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const userApi = baseApi.injectEndpoints({
  reducerPath: "userApi",
  endpoints: (builder) => ({
    updateUser: builder.mutation({
      query: (modifiedData) => {
        return {
          url: "update-user",
          method: "PATCH",
          body: modifiedData,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteUser: builder.mutation({
      query: (slug) => {
        return {
          url: `delete-user/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      invalidatesTags: ["deleteUser"],
    }),
    getAllUsers: builder.query({
      query: ({ search, limit, page }) => {
        return {
          url: `user-list?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useUpdateUserMutation,
  useDeleteUserMutation,
  useGetAllUsersQuery,
} = userApi;
